import { lazy } from 'react';

const Edit = lazy(() => import('./Edit'));

export { Edit };
